import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ResourcesService } from '../services/resources.service';

export const resourceDetailGuard: CanActivateFn = (route) => {

  const resourcesService = inject(ResourcesService);
  const router = inject(Router);

  const type = route.paramMap.get('type');
  const slug = route.paramMap.get('slug');

  if (!type || !slug) {
    return router.parseUrl('/not-found');
  }

  return resourcesService.getResource(type, slug)
    ? true
    : router.parseUrl('/not-found');

};